export const environment = {
    backendServerUrl: 'https://staging-parkadmin.lindskrog.se/parking-server',
    isProd: false,
    description: 'staging',
    version: require('../../package.json').version
};
